import i18next from 'i18next';

/**
 * Строгий перевод: возвращает значение только если ключ реально существует
 * в переводах, иначе undefined (t() для отсутствующего ключа вернул бы сам ключ).
 * Ключ передаётся абсолютным (с учётом ns и keyPrefix вызывающего).
 */
export function getStrictTranslation(key: string, ns?: string): string | undefined {
  return i18next.exists(key, ns ? { ns } : undefined) ? i18next.t(key, ns ? { ns } : undefined) : undefined;
}
